import { dateFormat } from "../../../util/DateUtil";

// As datas vêm em UTC; o dateFormat já trata isso, então o dia da semana é
// calculado a partir do texto formatado para não "voltar" um dia no fuso local.
export const diaDaSemana = (data) => {
  if (!data) return "";
  const [dia, mes, ano] = dateFormat(data).split("/").map(Number);
  return new Date(ano, mes - 1, dia).toLocaleDateString("pt-BR", { weekday: "long" });
};

const timestamp = (data) => {
  if (!data) return 0;
  const [dia, mes, ano] = dateFormat(data).split("/").map(Number);
  return new Date(ano, mes - 1, dia).getTime();
};

export const porData = (getData) => (a, b) => timestamp(getData(a)) - timestamp(getData(b));
